import React, { Fragment } from "react";
import { Col, Container, Row } from "reactstrap";
import { translate } from "react-switch-lang";
import Categories from "../categories/categories";
import New from "../news/news";
import Footer from "../template/footer";
import Taptop from "../template/tap-top";
import styles from "./home.module.scss";
import About from "./about/about";
import Header from "../header/header";
const Home: React.FC<{ t: (key: string) => {} }> = props => {
  return (
    <Fragment>
      <Taptop />
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <Header></Header>
        <div className={`${styles["plan"]} page-body-wrapper`}>
          <div className={`${styles["agrisud-page-body"]} ${styles["bg"]}  page-body`}>
            <Container fluid>
              <div className="page-title">
                <div>
                  <br />
                  <br />
                  <h2 className={styles["title"]}>{props.t("title_intro")}</h2>
                  <br />
                  {/* <h6 className={styles["title"]}>{props.t("title_intro_subtitle")}</h6> */}
                  <br />
                </div>
              </div>
              <Row>
                <Col md="4"></Col>
                <Col md="9"></Col>
                <Col sm="12" md="12" xl="8">
                  <Categories />
                </Col>
                <Col sm="12" md="12" xl="4">
                  <New />
                </Col>
              </Row>
            </Container>
          </div>
          <About />
          <Footer />
        </div>
      </div>
    </Fragment>
  );
};

export default translate(Home);
